import { Link } from 'react-router-dom'
import { ShieldCheck, Wrench, FileCheck2, Car, HandCoins, ArrowRight, Search, FileSignature, KeyRound } from 'lucide-react'
import { cars, brl, minParcela } from '../data.js'

const destaque = cars[0]

export default function Home() {
  return (
    <main>
      {/* Hero */}
      <section className="bg-gradient-to-b from-brand-50 to-cream">
        <div className="mx-auto grid max-w-6xl items-center gap-6 px-4 py-10 md:grid-cols-2 md:gap-10 md:py-24">
          <div>
            <span className="rounded-full bg-white px-3 py-1 text-xs font-semibold text-brand-700 shadow-sm">
              Aluguel com transferência de propriedade
            </span>
            <h1 className="font-display mt-4 text-3xl font-extrabold leading-tight tracking-tight text-slate-900 md:text-5xl">
              Seu carro começa<br />com um <span className="text-brand-600">Sim</span>.
            </h1>
            <p className="mt-3 max-w-md text-base text-slate-600 md:mt-4 md:text-lg">
              O banco disse não? A gente diz Sim. Você aluga, dirige desde o primeiro dia e, no fim, o carro é seu — com seguro e manutenção por nossa conta.
            </p>
            <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:flex-wrap md:mt-8">
              <Link to="/carros" className="rounded-full bg-brand-600 px-5 py-3 text-center text-sm font-semibold text-white shadow-md shadow-brand-600/20 transition hover:bg-brand-700 active:scale-[0.98] md:px-7 md:py-3.5 md:text-base">
                Ver carros disponíveis
              </Link>
              <a href="#como-funciona" className="rounded-full border border-slate-300 bg-white px-5 py-3 text-center text-sm font-semibold text-slate-700 transition hover:border-slate-400 active:scale-[0.98] md:px-7 md:py-3.5 md:text-base">
                Como funciona
              </a>
            </div>
          </div>
          <Link to={`/carros/${destaque.id}`} className="group relative block overflow-hidden rounded-3xl bg-white shadow-xl shadow-slate-900/10">
            <img src={destaque.fotos[0]} alt={destaque.nome} className="aspect-[16/10] w-full object-cover transition duration-500 group-hover:scale-105 md:aspect-[4/3]" />
            <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-slate-900/80 to-transparent p-4 text-white md:p-5">
              <div className="font-display text-sm font-bold md:text-base">{destaque.nome}</div>
              <div className="text-xs opacity-90 md:text-sm">a partir de <span className="font-bold">{brl(minParcela(destaque))}/mês</span> · tudo incluso</div>
            </div>
          </Link>
        </div>
      </section>

      {/* Benefícios */}
      <section className="mx-auto max-w-6xl px-4 py-8 md:py-16">
        <div className="grid gap-3 md:grid-cols-3 md:gap-5">
          {[
            { icon: ShieldCheck, t: 'Seguro incluso', d: 'O carro já vem segurado. Zero cotação, zero dor de cabeça.' },
            { icon: Wrench, t: 'Manutenção inclusa', d: 'Revisões e manutenção são por conta da Sim. Você só abastece.' },
            { icon: FileCheck2, t: 'Sem burocracia de financiamento', d: 'Análise simples e humana. Aqui, seu nome vale mais que seu score.' },
          ].map(({ icon: Icon, t, d }) => (
            <div key={t} className="flex items-start gap-4 rounded-2xl border border-slate-200 bg-white p-4 shadow-sm md:block md:p-6">
              <span className="inline-flex shrink-0 rounded-xl bg-brand-50 p-2.5 text-brand-700 md:p-3"><Icon size={22} /></span>
              <div>
                <div className="font-display text-base font-bold md:mt-4 md:text-lg">{t}</div>
                <p className="mt-0.5 text-sm text-slate-500 md:mt-1">{d}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Como funciona */}
      <section id="como-funciona" className="mx-auto max-w-6xl scroll-mt-20 px-4 py-6 pb-12 md:py-8 md:pb-20">
        <h2 className="font-display text-2xl font-extrabold tracking-tight text-slate-900 md:text-3xl">Como funciona</h2>
        <p className="mt-1 text-slate-500 md:mt-2">Três passos entre você e a chave do seu carro.</p>
        <div className="mt-5 grid gap-3 md:mt-8 md:grid-cols-3 md:gap-5">
          {[
            { icon: Search, n: '1', t: 'Escolha', d: 'Navegue pelo catálogo e escolha o carro e o plano de parcelas que cabem no seu bolso.' },
            { icon: FileSignature, n: '2', t: 'Proponha', d: 'Envie sua proposta e seus documentos pelo site. A gente liga pra você em seguida.' },
            { icon: KeyRound, n: '3', t: 'Dirija', d: 'Aprovou, assinou, dirigiu. Ao fim das parcelas, o carro é transferido pro seu nome.' },
          ].map(({ icon: Icon, n, t, d }) => (
            <div key={n} className="relative flex items-start gap-4 rounded-2xl border border-slate-200 bg-white p-4 shadow-sm md:block md:p-6">
              <div className="font-display absolute -top-4 left-6 hidden rounded-full bg-brand-600 px-3 py-1 text-sm font-bold text-white md:block">{n}</div>
              <span className="inline-flex shrink-0 rounded-xl bg-brand-50 p-2.5 text-brand-700 md:mt-2 md:p-3"><Icon size={22} /></span>
              <div>
                <div className="font-display text-base font-bold md:mt-4 md:text-lg"><span className="md:hidden">{n}. </span>{t}</div>
                <p className="mt-0.5 text-sm text-slate-500 md:mt-1">{d}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Investidor */}
      <section className="bg-brand-900">
        <div className="mx-auto grid max-w-6xl items-center gap-6 px-4 py-10 md:grid-cols-[1fr_auto] md:gap-8 md:py-16">
          <div>
            <span className="rounded-full bg-white/10 px-3 py-1 text-xs font-semibold text-brand-100">Para investidores</span>
            <h2 className="font-display mt-3 text-2xl font-extrabold tracking-tight text-white md:text-3xl">Invista com a Sim</h2>
            <p className="mt-2 max-w-2xl text-sm text-brand-100/90 md:mt-3 md:text-base">
              Coloque seu carro para vender no nosso modelo ou invista dinheiro para ampliarmos a frota. A Sim cuida de tudo: seguro, manutenção e a operação inteira.
            </p>
            <div className="mt-4 flex flex-wrap gap-x-4 gap-y-2 text-sm text-brand-100/80 md:mt-6">
              <span className="inline-flex items-center gap-2"><Car size={16} /> Consigne seu carro</span>
              <span className="inline-flex items-center gap-2"><HandCoins size={16} /> Invista a partir de R$ 10 mil</span>
            </div>
          </div>
          <Link to="/investir" className="inline-flex items-center justify-center gap-2 rounded-full bg-white px-5 py-3 text-sm font-semibold text-brand-800 shadow-lg transition hover:bg-brand-50 active:scale-[0.98] md:px-7 md:py-3.5 md:text-base">
            Quero investir <ArrowRight size={18} />
          </Link>
        </div>
      </section>
    </main>
  )
}
